<template>
    <div class="features-area mt-minus-40 pb-75">
        <div class="container">
            <div class="section-title">
                <span class="sub-title purple-color">Key Features</span>
                <h2 class="nunito-font">Most probably included best features ever</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200">
                    <div class="single-features-item style-two">
                        <div class="icon">
                            <i class="flaticon-comment"></i>
                        </div>
                        <h3 class="nunito-font">Live Chat Handover </h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est non feugiat sagittis, donec.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                    <div class="single-features-item style-two">
                        <div class="icon">
                            <i class="flaticon-analytics"></i>
                        </div>
                        <h3 class="nunito-font">Sentiment Analysis </h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est non feugiat feu sagittis, donec.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                    <div class="single-features-item style-two">
                        <div class="icon">
                            <i class="flaticon-artificial-intelligence"></i>
                        </div>
                        <h3 class="nunito-font">Artificial Intelligence</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est non feugiat feu sagittis, donec.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Features'
}
</script>